module.exports = __webpack_public_path__ + "static/media/pageNotFound.631269c1.jpg";